import PieChart from "../../../charts/pieChart";
import "../../../analytics.css";
import React from "react";
import NoDataComponent from "../../../../../reusableComponents/noDataComponent/NoDataComponent";
import { Skeleton } from "@mui/material";

const PieChartComponent = ({ data, chartOptions, pieChartData }) => {
  return (
    <div
      className="pie-chart"
      style={{ display: "flex", justifyContent: "center", width: "100%" }}
    >
      {data ? (
        data?.length >= 1 ? (
          <div className="w-100" style={{ height: "238px" }}>
            <PieChart chartData={pieChartData} options={chartOptions} />
          </div>
        ) : (
          <NoDataComponent />
        )
      ) : (
        <Skeleton
          variant="rounded"
          animation="wave"
          width={"100%"}
          height={"100%"}
        />
      )}
    </div>
  );
};

export default PieChartComponent;
